import styled from "styled-components";
import { colors } from "../../../../common/constants/color";

export const FormCard = styled.div`
    background: #fff;
    border: 1px solid #e3e9f0;
    border-radius: 20px;
    box-shadow: 0 18px 50px rgba(10, 10, 31, 0.08);
    overflow: hidden;
`

export const FormCardHead = styled.div`
    background: ${colors.primaryColor};
    color: #fff;
    padding: 24px 28px;

    h3 {
        color: #fff;
        font-size: 22px;
        margin: 0 0 4px;
    }

    p {
        margin: 0;
        color: #fff;
        opacity: 0.9;
        font-size: 14px;

        span {
            color: #ffb4b4;
        }
    }
`

export const FormCardBody = styled.div`
    padding: 26px 28px 30px;
`

export const FieldSet = styled.fieldset`
    border: none;
    padding: 0;
    margin: 0 0 22px;
`

export const Legend = styled.div`
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${colors.primaryColor};
    margin-bottom: 14px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #e3e9f0;
`

export const FormItem = styled.div`
    margin-bottom: 16px;
`

export const FormRow = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;

    @media only screen and (max-width: 540px) {
        grid-template-columns: 1fr;
    }
`

export const PhoneGroup = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;

    > div:first-child {
        width: 190px;
        flex-shrink: 0;
    }

    > div:last-child {
        flex: 1;
        min-width: 0;
    }

    @media only screen and (max-width: 420px) {
        flex-wrap: wrap;

        > div:first-child {
            width: 100%;
        }
    }
`

export const CheckBoxGroup = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 16px;
    border: 1.5px solid #e3e9f0;
    background: #fbfdff;
    border-radius: 11px;
    padding: 14px;

    &.wc-invalid {
        border-color: #e11d48;
    }

    @media only screen and (max-width: 540px) {
        grid-template-columns: 1fr;
    }
`

export const FieldLabel = styled.label`
    display: block;
    font-weight: 600;
    font-size: 14px;
    color: #1f2d3d;
    margin-bottom: 7px;

    span {
        color: #e11d48;
    }
`

export const FieldError = styled.div`
    color: #e11d48;
    font-size: 13px;
    margin-top: 6px;
`

export const UploadBox = styled.label`
    display: block;
    position: relative;
    border: 1.6px dashed #b9c0e6;
    background: #f5f6fe;
    border-radius: 14px;
    padding: 22px 18px;
    text-align: center;
    width: 100%;
    cursor: pointer;
    transition: border-color .15s ease, background .15s ease;

    &:hover {
        border-color: ${colors.primaryColor};
        background: #eef0fb;
    }

    &.wc-invalid {
        border-color: #e11d48;
    }

    input[type="file"] {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }

    svg {
        display: block;
        width: 34px;
        height: 34px;
        color: ${colors.primaryColor};
        margin: 0 auto 6px;
    }
`

export const UploadTitle = styled.div`
    font-weight: 600;
    color: #1f2d3d;
    font-size: 15px;
`

export const UploadHint = styled.div`
    color: #5c6b7a;
    font-size: 13px;
    margin-top: 3px;
`

export const UploadFileName = styled.div`
    margin-top: 10px;
    font-weight: 600;
    color: ${colors.primaryColor};
    font-size: 14px;
    word-break: break-all;
`

export const ErrorAlert = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 18px;
    font-size: 14px;
    line-height: 1.45;
    background: #fef2f3;
    border: 1px solid #f8d3d8;
    color: #b91c3a;
`

export const FormAction = styled.div`
    margin-top: 24px;

    a, button {
        width: 100%;
        justify-content: center;
    }
`

export const PrivacyNote = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-start;
    margin-top: 18px;
    color: #5c6b7a;
    font-size: 13px;
    line-height: 1.5;

    svg {
        width: 18px;
        height: 18px;
        color: ${colors.primaryColor};
        flex-shrink: 0;
        margin-top: 1px;
    }
`

export const SuccessBox = styled.div`
    text-align: center;
    padding: 40px 26px;

    h3 {
        color: ${colors.secondaryColor};
        font-size: 24px;
        margin-bottom: 10px;
    }

    p {
        color: #5c6b7a;
        line-height: 1.6;
        max-width: 420px;
        margin: 0 auto;
    }
`

export const SuccessIcon = styled.div`
    width: 76px;
    height: 76px;
    margin: 0 auto 18px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: ${colors.primaryColor};
    box-shadow: 0 12px 30px rgba(72, 78, 161, 0.3);

    svg {
        width: 40px;
        height: 40px;
        color: #fff;
    }
`
